
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"stroke":"currentColor","stroke-linejoin":"round","stroke-width":"1.5","d":"M17.498 19.498H6.665a.836.836 0 01-.834-.834v-.677a3.5 3.5 0 013.49-3.489h5.52a3.5 3.5 0 013.491 3.49v.676c0 .46-.373.833-.834.834zm-5.416-8.25a3.375 3.375 0 110-6.75 3.375 3.375 0 010 6.75v0z"}})])
          )
        }
      }
    